import { isAxiosError } from 'axios';

/** A failed API call, with the backend's message (and validation details, if any). */
export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly details: string[] = [],
  ) {
    super(message);
    this.name = 'ApiError';
  }

  get isClientError(): boolean {
    return this.status >= 400 && this.status < 500;
  }
}

const FALLBACK = 'Something went wrong. Please try again.';
const NETWORK = 'Cannot reach the server. Check your connection and try again.';

export const toApiError = (error: unknown): ApiError => {
  if (error instanceof ApiError) return error;
  if (isAxiosError<{ message?: unknown; error?: unknown }>(error)) {
    if (!error.response) return new ApiError(NETWORK, 0);
    const body = error.response.data;
    const message = typeof body?.message === 'string' && body.message ? body.message : FALLBACK;
    const details = Array.isArray(body?.error) ? body.error.filter((d): d is string => typeof d === 'string') : [];
    return new ApiError(message, error.response.status, details);
  }
  return new ApiError(FALLBACK, 0);
};

/** A message safe to show the user. */
export const errorMessage = (error: unknown): string => toApiError(error).message;
